import React from 'react';
import { Circle, G, Line, Polygon, Rect, Text as SvgText } from 'react-native-svg';
import { DiagramCanvas } from '../DiagramCanvas';
import { FormulaTag } from '../FormulaTag';
import { LeaderLine } from '../LeaderLine';
import { DT } from '../tokens';

/** TP = SP + VP — show three taps: total (impact), static (wall), velocity = TP − SP. */
export function DiagramTotalPressure() {
  const dx = 30, dy = 105, dw = 290, dh = 70;
  const cy = dy + dh / 2;

  // Probe positions
  const totalX = dx + 70;
  const staticX = dx + 170;

  return (
    <DiagramCanvas>
      {/* Duct */}
      <Rect x={dx} y={dy} width={dw} height={dh} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.5" />

      {/* Velocity profile streamlines */}
      {[0.15, 0.35, 0.5, 0.65, 0.85].map((t, i) => {
        const yp = dy + dh * t;
        const len = 50 * (1 - Math.pow((t - 0.5) * 2, 2));
        return (
          <G key={i}>
            <Line x1={dx + 8} y1={yp} x2={dx + 8 + len} y2={yp} stroke={DT.arrow} strokeWidth="1" opacity={0.7} />
            <Polygon points={`${dx + 8 + len},${yp} ${dx + 4 + len},${yp - 2} ${dx + 4 + len},${yp + 2}`}
              fill={DT.arrow} opacity={0.7} />
          </G>
        );
      })}

      {/* TOTAL pressure probe — impact tube facing flow */}
      <Line x1={totalX} y1={dy - 30} x2={totalX} y2={cy + 4} stroke={DT.leader} strokeWidth="3" />
      <Line x1={totalX - 12} y1={cy} x2={totalX} y2={cy} stroke={DT.leader} strokeWidth="3" />
      <Circle cx={totalX - 12} cy={cy} r={2.5} fill={DT.varColor} />
      {/* Gauge for TP */}
      <Circle cx={totalX} cy={dy - 42} r={11} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <Line x1={totalX} y1={dy - 42} x2={totalX - 6} y2={dy - 48} stroke={DT.varColor} strokeWidth="1.5" />
      <SvgText x={totalX} y={dy - 56} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">TP</SvgText>

      {/* STATIC pressure tap — flush wall tap */}
      <Line x1={staticX} y1={dy} x2={staticX} y2={dy - 30} stroke={DT.leader} strokeWidth="2" />
      <Circle cx={staticX} cy={dy} r={2} fill={DT.varColor} />
      <Circle cx={staticX} cy={dy - 42} r={11} fill={DT.fill} stroke={DT.stroke} strokeWidth="1.2" />
      <Line x1={staticX} y1={dy - 42} x2={staticX + 5} y2={dy - 47} stroke={DT.varColor} strokeWidth="1.5" />
      <SvgText x={staticX} y={dy - 56} fill={DT.varColor} fontSize="9" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">SP</SvgText>

      {/* VP indicator: TP − SP */}
      <Line x1={totalX + 14} y1={dy - 75} x2={staticX - 14} y2={dy - 75} stroke={DT.varColor} strokeWidth="1" />
      <Polygon points={`${totalX + 14},${dy - 75} ${totalX + 20},${dy - 72} ${totalX + 20},${dy - 78}`} fill={DT.varColor} />
      <Polygon points={`${staticX - 14},${dy - 75} ${staticX - 20},${dy - 72} ${staticX - 20},${dy - 78}`} fill={DT.varColor} />
      <SvgText x={(totalX + staticX) / 2} y={dy - 78} fill={DT.varColor}
        fontSize="10" fontFamily={DT.mono} textAnchor="middle" fontWeight="700">VP = TP − SP</SvgText>

      {/* Equation badges in duct */}
      <Rect x={dx + 200} y={cy - 10} width={75} height={20} fill="rgba(0,0,0,0.5)" stroke={DT.varColor} strokeWidth="0.8" />
      <SvgText x={dx + 237} y={cy + 4} fill={DT.varColor} fontSize="10"
        fontFamily={DT.mono} textAnchor="middle" fontWeight="700">TP = SP+VP</SvgText>

      {/* Labels */}
      <LeaderLine x1={totalX - 12} y1={cy} x2={20} y2={210} varName="TP" desc="impact (total)" anchor="start" />
      <LeaderLine x1={staticX} y1={dy + 4} x2={150} y2={210} varName="SP" desc="wall (static)" anchor="middle" />
      <LeaderLine x1={dx + dw - 30} y1={cy} x2={310} y2={210} varName="VP" desc="velocity" anchor="end" />

      <FormulaTag formula="TP = SP + VP   (all in. w.g.)" />
    </DiagramCanvas>
  );
}
